import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import DemandSettingDataEdit_TJ360VersionDevice from '../polling/pollingTopicDetails_TJ360VersionDevice/DemandSettingDataEdit_TJ360VersionDevice';

export type SelectDemandSettingDataDialog_TJ360DeviceVersionProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
};

export const SelectDemandSettingDataDialog_TJ360DeviceVersion = (props: SelectDemandSettingDataDialog_TJ360DeviceVersionProps) => {
    const { isOpen, onOK, onCancel, data } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>デマンド設定値</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <DemandSettingDataEdit_TJ360VersionDevice onCancel={handleCancel} demandSettingData={data} onOK={(data) => handleUpdate(data)}></DemandSettingDataEdit_TJ360VersionDevice>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectDemandSettingDataDialog_TJ360DeviceVersion;